import PropTypes from 'prop-types';
import React from 'react';
import { actionOnKeyboardPress } from '../utils/browserUtils';

export default class TextField extends React.Component {
    getClearButtonStyles() {
        const styles = ['clear-button'];

        if (this.props.isDisabled) {
            styles.push('disabled');
        }

        if (!this.props.isVisible) {
            styles.push('hidden');
        }

        return styles.join(' ');
    }

    render() {
        return (
            <div
                className="text-field">
                <div
                    className="text-field-inner"
                    role="note"
                    aria-label={this.props.text}
                    tabIndex={this.props.isDisabled ? '-1' : 0}>
                    {this.props.text}
                </div>
                <div
                    role="button"
                    tabIndex={this.props.isDisabled ? '-1' : 0}
                    aria-label="Clear button"
                    className={this.getClearButtonStyles()}
                    onKeyDown={(e) => actionOnKeyboardPress(e, this.props.onClearButtonClick)}
                    onClick={this.props.onClearButtonClick}
                    id="clear-button"
                />
            </div>
        );
    }
}

TextField.propTypes = {
    text: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    isVisible: PropTypes.bool,
    onClearButtonClick: PropTypes.func,
};

TextField.defaultProps = {
    isDisabled: false,
    isVisible: true,
    onClearButtonClick: () => {},
};
